"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTrash(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M18.75 24a2.17 2.17 0 001.594-.656A2.17 2.17 0 0021 21.75V4.5h1.219c.062 0 .125-.031.187-.094.063-.062.094-.125.094-.187v-.094c0-.313-.11-.578-.328-.797A1.085 1.085 0 0021.375 3H17.25L15.656.89C15.22.298 14.625 0 13.875 0h-3.75c-.75 0-1.344.297-1.781.89L6.75 3H2.625c-.313 0-.578.11-.797.328a1.085 1.085 0 00-.328.797v.094c0 .062.031.125.094.187.062.063.125.094.187.094H3v17.25c0 .625.219 1.156.656 1.594A2.17 2.17 0 005.25 24h13.5zM15.375 3h-6.75l.89-1.219a.756.756 0 01.61-.281h3.75c.25 0 .453.094.61.281L15.374 3zm3.375 19.5H5.25a.73.73 0 01-.54-.21.73.73 0 01-.21-.54V4.5h15v17.25a.73.73 0 01-.21.54.73.73 0 01-.54.21zm-6.563-2.25c.157 0 .29-.055.399-.164a.542.542 0 00.164-.398V7.313a.542.542 0 00-.164-.399.542.542 0 00-.399-.164h-.374a.542.542 0 00-.399.164.542.542 0 00-.164.399v12.375c0 .156.055.289.164.398.11.11.242.164.399.164h.374zm-3.75 0c.157 0 .29-.055.399-.164A.542.542 0 009 19.688V7.313a.542.542 0 00-.164-.399.542.542 0 00-.399-.164h-.374a.542.542 0 00-.399.164.542.542 0 00-.164.399v12.375c0 .156.055.289.164.398.11.11.242.164.399.164h.374zm7.5 0c.157 0 .29-.055.399-.164a.542.542 0 00.164-.398V7.313a.542.542 0 00-.164-.399.542.542 0 00-.398-.164h-.376a.542.542 0 00-.398.164.542.542 0 00-.164.399v12.375c0 .156.055.289.164.398.11.11.242.164.399.164h.374z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgTrash;
exports.default = _default;